import { GetAllTinybirdEventsFrontendRequestBodyType } from "@intelligems/ig-types";
import { api } from "@src/api/api";
import { combinedCustomEventsKeys } from "@src/api/queryKeys";
import { useQuery } from "@tanstack/react-query";

const getAllCombinedCustomEvents = async () => {
  const resp = await api.get<any>("/v2/custom-events/combined");
  return resp.data;
};

export const useGetAllCombinedCustomEvents = () => {
  return useQuery<any>({
    queryKey: combinedCustomEventsKeys.all,
    queryFn: async () => getAllCombinedCustomEvents(),
  });
};
